import ExclamationMarkIcon from "@components/common/icons/exclamation-mark.icon";
import { Box } from "@mui/material";
import type { Delivery } from "@types_def/models/delivery.types";
import { DeliveryStatus } from "@types_def/models/delivery.types";
import { getDeliveryTypeColor } from "@utils/functions/Delivery/DeliveryType/deliveryTypeAttributes";

export default function ContractCell({ children }: { children: Delivery }) {
  const { type, publicId, status } = children;
  const cancelledStatuses: readonly string[] = [
    DeliveryStatus.CANCELLED_BY_CUSTOMER,
    DeliveryStatus.CANCELLED_BY_ADMIN,
    DeliveryStatus.CANCELLED_BY_MANDATORY,
  ];
  const cancelled = cancelledStatuses.includes(status);
  const color = getDeliveryTypeColor(type);
  return (
    <Box sx={{ display: "flex", gap: "0.5rem", alignItems: "center" }}>
      {cancelled && (
        <Box
          sx={{
            width: "fit-content",
            height: 16,
            "& svg": { mr: 0, "& *": { fill: "#d81a1a" } },
          }}
        >
          <ExclamationMarkIcon />
        </Box>
      )}
      <Box sx={{ borderRadius: "50%", width: 20, height: 20, background: color }} />
      <Box>{publicId}</Box>
    </Box>
  );
}
